import { ContinuouslyUsedMedicineIcon, IconFillColor, IconSize } from '@dreryk/react-components';

import { StyledContinuouslyUsedMedicineIconWrapper } from './StyledContinuouslyUsedMedicineIconWrapper';

StyledContinuouslyUsedMedicineIconWrapper.displayName = 'StyledContinuouslyUsedMedicineIconWrapper';

const ContinuouslyUsedMedicinePlaceholderIcon = (): JSX.Element => (
   <StyledContinuouslyUsedMedicineIconWrapper
      fillColor={IconFillColor.BASIC}
      size={IconSize.SMALL}
      testId={'continuouslyUsedMedicinePlaceholder'}
   >
      <ContinuouslyUsedMedicineIcon />
   </StyledContinuouslyUsedMedicineIconWrapper>
);

export { ContinuouslyUsedMedicinePlaceholderIcon };
